import { useFieldArray, useFormContext } from 'react-hook-form';

import { TaskTemplateFormValues } from '@web/shiftTasks/ComposeTask/types/TaskTemplateFormValues';

export function useSubtasksField() {
  const { setValue } = useFormContext<TaskTemplateFormValues>();
  const { append, fields, move, remove } = useFieldArray<TaskTemplateFormValues, 'subtasks'>({
    name: 'subtasks',
  });

  const removeSubtask = (index: number) => {
    const subtask = fields[index];
    if (!subtask.isNewRecord) {
      setValue(`subtasks.${index}.isDeleted`, true, { shouldDirty: true });
    } else {
      remove(index);
    }
  };

  return {
    append,
    fields,
    move,
    remove: removeSubtask,
  };
}
